import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const redirectUrl = route['_routerState']['url'];

    const requiresLogin = route.data.requiresLogin || false;
    if (requiresLogin == true) {
      if (this.isLogged()) {
        return true;
      }

      this.router.navigateByUrl(
        this.router.createUrlTree(
          ['/login'], { 
        }
        )
      );

      return false;
    } else {
      return true
    }

  }

  isLogged() {
    if (localStorage.getItem("isLoggedIn") == "true") {
      return true
    } else {
      localStorage.clear()
      return false
    }

  }

}